module.exports = __webpack_public_path__ + "img/tk.2cc6125.svg";